import React from "react";
import { ArrowUpRight, Star } from "lucide-react";
import { logos } from "../data/mock";
import { Reveal } from "./ui/Reveal";

const Hero = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 pt-16 pb-10 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase text-neutral-500 border border-black/10 rounded-full px-3 py-1.5 bg-white/60">
            <span className="w-1.5 h-1.5 rounded-full bg-black"></span> Your growth partner
          </span>
        </Reveal>

        <Reveal delay={0.1}>
          <h1 className="mt-6 text-[36px] sm:text-[58px] leading-[1.06] tracking-[-0.03em] font-semibold text-neutral-950 max-w-4xl mx-auto">
            Driving predictable revenue through data-driven performance marketing
          </h1>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-6 text-[17px] text-neutral-600 max-w-xl mx-auto">
            Trusted growth marketing consultant helping businesses, startups, and agencies scale with proven paid advertising strategies that deliver measurable ROI.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-8 flex items-center justify-center gap-4 flex-wrap">
            <div className="relative inline-flex group">
              <div className="absolute -inset-1 rounded-xl opacity-60 blur-lg bg-gradient-to-r from-cyan-400 via-blue-500 to-fuchsia-500 transition-opacity duration-300 group-hover:opacity-90" />
              <a
                href="/connect"
                className="relative z-10 flex items-center gap-2 bg-black text-white pl-5 pr-4 py-3 rounded-xl text-[15px] font-medium transition-transform duration-200 group-hover:-translate-y-0.5"
              >
                Book a strategy call
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
            <a
              href="/success-stories"
              className="flex items-center gap-2 text-[15px] font-medium text-neutral-800 border border-black/10 pl-5 pr-4 py-3 rounded-xl hover:bg-neutral-50 transition-colors"
            >
              See success stories
            </a>
          </div>

          {/* 5-star + "CXO Recommended" trust line, sits under the CTA buttons */}
          <div className="mt-6 flex items-center justify-center gap-2">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-black text-black" />
              ))}
            </div>
            <span className="text-sm text-neutral-600 font-medium">CXO Recommended</span>
          </div>
        </Reveal>
      </div>

      {/* Logo strip — infinite right-to-left marquee with a soft fade at
          both edges (.logo-marquee-mask, defined in index.css). */}
      <Reveal delay={0.15}>
        <div className="max-w-[1280px] mx-auto px-6 py-14">
          <p className="text-center text-sm text-neutral-500 mb-8">Trusted by growth-focused teams across industries</p>
          <div className="relative w-full overflow-hidden logo-marquee-mask">
            <div className="animate-marquee items-center gap-16">
              {[...logos, ...logos].map((logo, i) => (
                <img
                  key={`${logo.alt}-${i}`}
                  src={logo.src}
                  alt={logo.alt}
                  className="h-7 w-auto object-contain opacity-75 flex-shrink-0"
                />
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default Hero;
